import { Box, Loader } from '@wix/design-system';
import React from 'react';
import { CheckoutLoadingSkeleton } from './CheckoutLoadingSkeleton';
import { useIsCheckoutSkeleton } from './useIsCheckoutSkeleton';
export const CheckoutLoading = _ref => {
  let {
    isMobile = false
  } = _ref;
  const isSkeletonEnabled = useIsCheckoutSkeleton();
  if (isSkeletonEnabled) {
    return /*#__PURE__*/React.createElement(CheckoutLoadingSkeleton, {
      isMobile: isMobile
    });
  }
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    align: "center",
    verticalAlign: "middle",
    height: "500px",
    dataHook: "checkout-loading-spinner"
  }, /*#__PURE__*/React.createElement(Loader, null));
};
//# sourceMappingURL=CheckoutLoading.js.map